import React from 'react'

/**
 * Lightspeed system icon with favicon and SVG fallback
 */
export const LightspeedIcon: React.FC<{ sx?: any; size?: number }> = ({ 
  sx, 
  size = 24 
}) => (
  <>
    <img
      src="https://www.lightspeedhq.com.au/favicon.svg?v=5"
      alt="Lightspeed"
      width={size}
      height={size}
      style={{
        display: 'block',
        borderRadius: '4px',
        ...sx
      }}
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        target.style.display = 'none';
        target.nextElementSibling?.setAttribute('style', 'display: inline-block');
      }}
    />
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'none', ...sx }}
    >
      <rect width="24" height="24" rx="4" fill="#0c4465"/>
      <text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold">LS</text>
    </svg>
  </>
)

/**
 * Skimmer system icon with favicon and SVG fallback
 */
export const SkimmerIcon: React.FC<{ sx?: any; size?: number }> = ({ 
  sx, 
  size = 24 
}) => (
  <>
    <img
      src="/skimmer.ico"
      alt="Skimmer"
      width={size}
      height={size}
      style={{
        display: 'block',
        borderRadius: '4px',
        ...sx
      }}
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        target.style.display = 'none';
        target.nextElementSibling?.setAttribute('style', 'display: inline-block');
      }}
    />
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'none', ...sx }}
    >
      <rect width="24" height="24" rx="4" fill="#1976d2"/>
      <text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold">SK</text>
    </svg>
  </>
)

/**
 * Get system icon component by system name
 */
export const getSystemIcon = (system: string, props?: { sx?: any; size?: number }) => {
  switch (system.toLowerCase()) {
    case 'lightspeed':
      return <LightspeedIcon {...props} />
    case 'skimmer':
      return <SkimmerIcon {...props} />
    default:
      return null
  }
}